<template>
  <div>
    <!--  <vs-navbar v-model="activeItem" class="p-5">-->

    <!--    <div slot="title">-->
    <!--      <vs-navbar-title>-->
    <!--        <span>HR & PEOPLES</span>-->
    <!--      </vs-navbar-title>-->
    <!--    </div>-->
    <!--    <vs-spacer></vs-spacer>-->

    <!--    <vs-navbar-item index="0">-->
    <!--      <a href="#">Home</a>-->
    <!--    </vs-navbar-item>-->

    <!--    <vs-navbar-item index="1">-->
    <!--      <a href="#">News</a>-->
    <!--    </vs-navbar-item>-->

    <!--    <vs-navbar-item index="2">-->
    <!--      <a href="#">Update</a>-->
    <!--    </vs-navbar-item>-->
    <!--  </vs-navbar>-->

    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3" @click="rmOrders" v-if="$can('view-order')">
        <router-link to="/pages/trading-summary/rm-orders">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="CircleIcon"
            icon-right
            statistic="Raw Material Orders"
            statisticTitle=""/>
        </router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3" v-if="$can('view-raw-material')">
        <router-link to="/pages/raw-materials">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="TriangleIcon"
            icon-right
            statistic="Raw Materials"
            statisticTitle=""
            color="success"/>
        </router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3" v-if="$can('view-site')">
        <router-link to="/pages/supplier-manufacturing">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="BoxIcon"
            icon-right
            statistic="Manufacturing Sites"
            statisticTitle=""
            color="danger"/>
        </router-link>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3" v-if="$can('view-user')">
        <router-link to="/pages/supplier-profile">
          <statistics-card-line
            hideChart
            class="mb-base"
            icon="UsersIcon"
            icon-right
            statistic="Supplier Users"
            statisticTitle=""
            color="warning"/>
        </router-link>
      </div>
    </div>
    <!-- ROW 3 -->
    <!--  <div class="vx-row">-->
    <!--    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
    <!--      <statistics-card-line-->
    <!--        color="dark"-->
    <!--        class="mb-base"-->
    <!--        v-if="subscribers_gained.analyticsData"-->
    <!--        icon="UsersIcon"-->
    <!--        :statistic="subscribers_gained.analyticsData.subscribers"-->
    <!--        statisticTitle="Customers Gained"-->
    <!--        :chartData="subscribers_gained.series"-->
    <!--        type="area" />-->
    <!--    </div>-->

    <!--    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
    <!--      <statistics-card-line-->
    <!--        class="mb-base"-->
    <!--        v-if="revenueGenerated.analyticsData"-->
    <!--        icon="DollarSignIcon"-->
    <!--        :statistic="revenueGenerated.analyticsData.revenue"-->
    <!--        statisticTitle="Revenue Generated"-->
    <!--        :chartData="revenueGenerated.series"-->
    <!--        color="success"-->
    <!--        type="area" />-->
    <!--    </div>-->

    <!--    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
    <!--      <statistics-card-line-->
    <!--        class="mb-base"-->
    <!--        v-if="quarterlySales.analyticsData"-->
    <!--        icon="ShoppingCartIcon"-->
    <!--        :statistic="quarterlySales.analyticsData.sales"-->
    <!--        statisticTitle="Quarterly Sales"-->
    <!--        :chartData="quarterlySales.series"-->
    <!--        color="danger"-->
    <!--        type="area" />-->
    <!--    </div>-->
    <!--    <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
    <!--      <statistics-card-line-->
    <!--        class="mb-base"-->
    <!--        v-if="ordersRecevied.analyticsData"-->
    <!--        icon="ShoppingBagIcon"-->
    <!--        :statistic="ordersRecevied.analyticsData.orders"-->
    <!--        statisticTitle="Orders Received"-->
    <!--        :chartData="ordersRecevied.series"-->
    <!--        color="warning"-->
    <!--        type="area" />-->
    <!--    </div>-->
    <!--  </div>-->
    <!--  <div class="row">-->
    <!--    <div class="vx-col w-full mb-base">-->
    <!--      <vx-card title="Revenue">-->

    <!--        <template slot="actions">-->
    <!--          <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>-->
    <!--        </template>-->

    <!--        <div slot="no-body" class="p-6 pb-0">-->

    <!--          <div class="flex" v-if="revenueComparisonLine.analyticsData">-->
    <!--            <div class="mr-6">-->
    <!--              <p class="mb-1 font-semibold">This Month</p>-->
    <!--              <p class="text-3xl text-success"><sup class="text-base mr-1">£ </sup>{{ revenueComparisonLine.analyticsData.thisMonth.toLocaleString() }}</p>-->
    <!--            </div>-->
    <!--            <div>-->
    <!--              <p class="mb-1 font-semibold">Last Month</p>-->
    <!--              <p class="text-3xl"><sup class="text-base mr-1">£ </sup>{{ revenueComparisonLine.analyticsData.lastMonth.toLocaleString() }}</p>-->
    <!--            </div>-->
    <!--          </div>-->

    <!--          <vue-apex-charts-->
    <!--            type="line"-->
    <!--            height="266"-->
    <!--            :options="analyticsData.revenueComparisonLine.chartOptions"-->
    <!--            :series="revenueComparisonLine.series" />-->
    <!--        </div>-->
    <!--      </vx-card>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--  <div class="vx-row">-->
    <!--    <div class="vx-col w-full md:w-2/3">-->
    <!--      <vx-card title="Client Retention">-->
    <!--        <div class="flex">-->
    <!--          <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>New Clients</span></span>-->
    <!--          <span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>Retained Clients</span></span>-->
    <!--        </div>-->
    <!--        <vue-apex-charts type="bar" height="277" :options="clientRetentionBarChartOptions" :series="analyticsData.clientRetentionBar.series" />-->
    <!--      </vx-card>-->
    <!--    </div>-->
    <!--  </div>-->
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData'
import VueApexCharts from 'vue-apexcharts'
import store from '../store/store.js'


export default {
  components: {
    StatisticsCardLine,
    VueApexCharts
  },
  data() {
    return {
      activeItem: 0,
      subscribers_gained: {
        series: [
          {
            name: 'Subscribers',
            data: [28, 40, 36, 52, 38, 60, 55]
          }
        ],
        analyticsData: {
          subscribers: 12400
        }
      },
      revenueGenerated: {
        series: [
          {
            name: 'Revenue',
            data: [350, 275, 400, 300, 350, 300, 450]
          }
        ],
        analyticsData: {
          revenue: 97500
        }
      },
      quarterlySales: {
        series: [
          {
            name: 'Sales',
            data: [10, 15, 7, 12, 3, 16]
          }
        ],
        analyticsData: {
          sales: '36%'
        }
      },
      ordersRecevied: {
        series: [
          {
            name: 'Orders',
            data: [10, 15, 8, 15, 7, 12, 8]
          }
        ],
        analyticsData: {
          orders: 97500
        }
      },
      analyticsData,
      revenueComparisonLine: {
        analyticsData: {
          thisMonth: 86589,
          lastMonth: 73683
        },
        series: [
          {
            name: 'This Month',
            data: [45000, 47000, 44800, 47500, 45500, 48000, 46500, 48600]
          },
          {
            name: 'Last Month',
            data: [46000, 48000, 45500, 46600, 44500, 46500, 45000, 47000]
          }
        ]
      },
      clientRetentionBarChartOptions: {
        grid: {
          borderColor: '#ebebeb',
          padding: {
            left: 0,
            right: 0
          }
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        chart: {
          stacked: true,
          type: 'bar',
          toolbar: {show: false}
        },
        colors: ['#ffb921', '#ffb921'],
        plotOptions: {
          bar: {
            columnWidth: '10%'
          }
        },
        xaxis: {
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          },
          axisTicks: {
            show: false
          },
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          }
        },
        tooltip: {
          x: {show: false}
        }
      },
    }
  },
  mounted() {
    // console.log(store.getters.permissions)
    // console.log(this.$can('view-staff'))
  }
}
</script>


<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
